<template>
    <div>
        <div  class="w-full">
                <div class="row">
                    <div class="col-md-4 col-12 d-flex mb-2">
                        <input ref="filter" type="search" class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-2 rounded-full ml-3 text-sm"
                               placeholder="Search by name..." @input="debounceFilter" v-model="filter">
                        <div class="flex-1 text-right pr-3">
                            <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                        </div>
                    </div>
                    <!-- <div class="col-md-8 col-12 d-flex justify-content-end">
                        <button href="/company/create"
                                class="mr-1 focus:outline-none font-semibold bg-followup-nav text-white p-2 rounded-full text-sm"
                                @click="()=>{advanced_search = !advanced_search}">Advanced search</button>
                    </div> -->
                </div>
            </div>
        <div v-if="zero_search_results || companies.length > 0">

            <div v-if="zero_search_results">
                <div class="mt-32 text-center text-grey-darkest text-lg">No results found. No company details has been shared yet.</div>
            </div>
            <div v-if="companies.length > 0" class="bg-white shadow-md rounded mb-6 mt-4">

                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th v-for="column in columnsToShow" :class="(column.property_name != 'name' && column.property_name != 'contact_name')  ? 'hidden' : ''" class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">

                            <button v-if="availableSort[column.property_name]" class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                    :class="currentOrder.sortBy === column.property_name ? 'text-teal' : ''"
                                    @click="sortByColumn(column.property_name)">
                                {{ column.name }}
                                <i class="fa fa-xs ml-2" :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                    'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                   v-if="currentOrder.sortBy === column.property_name"></i>
                            </button>
                            <button v-else class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none">
                                {{ column.name }}
                            </button>
                        </th>

<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold':sort.colunm === 'sequential_team_id'}" @click="sortBy('sequential_team_id')">-->
<!--                            Company Id-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'sequential_team_id'">-->
<!--                            </i>-->
<!--                        </th>-->

<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold':sort.colunm === 'name'}" @click="sortBy('name')">-->
<!--                            Company-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'name'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'contact'}" @click="sortBy('contact')">-->
<!--                            Contact-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'contact'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'email'}" @click="sortBy('email')">-->
<!--                            Email-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'email'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'fax'}" @click="sortBy('fax')">-->
<!--                            Fax-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'fax'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'address'}" @click="sortBy('address')">-->
<!--                            Address-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'address'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'state'}" @click="sortBy('state')">-->
<!--                            State-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'state'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'zip'}" @click="sortBy('zip')">-->
<!--                            ZIP-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'zip'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                         <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'company_type'}" @click="sortBy('company_type')">-->
<!--                            Company Type-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'company_type'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'pipeline'}" @click="sortBy('pipeline')">-->
<!--                            Pipeline-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'pipeline'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'closing_ratio'}" @click="sortBy('closing_ratio')">-->
<!--                            Closing Ratio-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'closing_ratio'">-->
<!--                            </i>-->
<!--                        </th>-->
                        <!-- <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer">
                            <div class="d-flex justify-content-center">
                                <company-export-icon
                                name="Companies"
                                :companies="companies"
                                :state="columns"
                                :filter="current_search_pattern"
                                v-on:stateUpdated="updateColumnState"
                            />
                            </div>
                        </th> -->
                        <th class="bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr @click="showCompany(company)" class="hover:bg-grey-lighter cursor-pointer border-b-1 text-grey-darkest" v-for="(company, idx) in companies" :key="idx">
                        <td v-for="column in columnsToShow" class="pl-2 border-b border-grey-light text-xs md:table-cell"
                            :class="(column.property_name != 'name' && column.property_name != 'contact')  ? 'hidden' : ''"
                        >
                            <div v-show="column.property_name == 'name'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.name }}
                                <br>
                                <a v-if="company.phone" :href="`tel:${company.phone}`" class="text-teal hover:text-teal-dark">
                                    <formatted-phone
                                        v-if="company.phone" :phone="company.phone" :masks="company.masks"/>
                                </a>
                            </div>

                            <div v-show="column.property_name == 'address'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.address }}
                            </div>

                            <div v-show="column.property_name == 'contact'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.contact ? contractName(company) : '' }}
                            </div>

                            <div v-show="column.property_name == 'company_type'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ `${company.company_type ? company.company_type.code : ''}` }}
                            </div>

                            <div v-show="column.property_name == 'fax'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                <formatted-phone
                                    v-if="company['fax']" :phone="company['fax']" :masks="company.masks"/>
                            </div>
                            <a v-show="column.property_name == 'email'" :href="`mailto:${company.contact.email ? company.contact.email : ''}`"
                               class="text-teal hover:text-teal-dark" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.contact.email }}
                            </a>
                            <span v-show="column.property_name != 'name' && column.property_name != 'address' && column.property_name != 'email'
                                    && column.property_name != 'contact' && column.property_name != 'fax' && column.property_name != 'company_type'"
                                  :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company[column.property_name] }}
                            </span>
                        </td>
                        <td class="px-4 border-b border-grey-light text-right hidden xl:table-cell">
                            <span class="material-icons">chevron_right</span>
                        </td>
<!--                        <td class="text-xs pl-4 py-1">-->
<!--                            <div class="text-sm">{{ company.sequential_team_id }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div class="text-sm">{{ company.name }}</div>-->
<!--                            <a v-if="company.phone" :href="`tel:${company.phone}`" class="text-teal hover:text-teal-dark">-->
<!--                                <formatted-phone-->
<!--                                    v-if="company.phone"-->
<!--                                    :phone="company.phone"-->
<!--                                    :masks="masks"/>-->
<!--                            </a>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1" style="word-break: break-all">-->
<!--                            <div v-if="company.contact">-->
<!--                                {{contractName(company)}}-->
<!--                            </div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div><a :href="`mailto:${company.contact.email}`" class="text-teal hover:text-teal-dark">{{ company.contact.email }}</a></div>-->
<!--                        </td>-->
<!--                         <td class="text-xs pl-2">-->
<!--                            <div>-->
<!--                                <formatted-phone-->
<!--                                    v-if="company.fax"-->
<!--                                    :phone="company.fax"-->
<!--                                    :masks="masks"/>-->
<!--                            </div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2" style="word-break: break-all">-->
<!--                            <div>{{ company.address }}</div>-->
<!--                            <div>{{ company.city }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2">-->
<!--                            <div>{{ company.state }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2">-->
<!--                            <div>{{ company.zip }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2">-->
<!--                            <div>{{ `${company.company_type ? company.company_type.code : ''}` }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div>{{ company.pipeline_value }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div>{{ company.closing_ratio }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-right">-->
<!--                            <span class="material-icons">chevron_right</span>-->
<!--                        </td>-->
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center">
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                >
                </b-pagination>
            </div>
        </div>
        <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div v-else class="mt-32 text-center text-grey-darkest text-lg">No results found. No company details has been shared yet.</div>
<!--        <div v-else class="mt-10 text-center">-->
<!--            <div class="flex-col">-->
<!--                <div>-->
<!--                    <img width="400" src="images/empty.svg">-->
<!--                </div>-->
<!--                <div class="mt-4">-->
<!--                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">-->
<!--                        <div class="text-xl w-1/4 tracking-wide">You haven't created a company yet!</div>-->
<!--                    </div>-->
<!--                    <button @click="addCompany" class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">Click here to add your first company!</button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
    import FormattedPhone from '../shared/formatted-phone.vue';
    import Multiselect from 'vue-multiselect';
    import Datepicker from 'vuejs-datepicker';
    import CompanyExportIcon from "../project/company-export-icon";
    import draggable from 'vuedraggable';

    export default {
        name:'my-companies',
        // props:['masks', 'symbols', 'userRole'],
        props:{
            availableColumns: {
                type: Array,
            },
            masks: {},
            state: {
                type: Array,
            },
            symbols: {},
            userRole:{},
            availableSort: {},
            customFields: {
                type: Array,
            },
            sharedAvailableColumns: {
                type: Array
            }
        },
        components: {draggable},
        data() {
            let companyState = this.state
            const stateCustomFields = this.customFields.map(customField => ({
                name: customField.label_value,
                checked: true,
                property_name: customField.name,
            }));
            let newState = [
                {
                    name: 'Company ID',
                    checked: true,
                    property_name: 'sequential_team_id',
                },
                {
                    name: 'Company',
                    checked: true,
                    property_name: 'name',
                },
                {
                    name: 'Child Companies',
                    checked: true,
                    property_name: 'child_companies',
                },
                {
                    name: 'Contact',
                    checked: true,
                    property_name: 'contact',
                },
                {
                    name: 'Email',
                    checked: true,
                    property_name: 'email',
                },
                {
                    name: 'Fax',
                    checked: true,
                    property_name: 'fax',
                },
                {
                    name: 'Address',
                    checked: true,
                    property_name: 'address',
                }, {
                    name: 'City',
                    checked: true,
                    property_name: 'city',
                },
                {
                    name: 'State',
                    checked: true,
                    property_name: 'state',
                },
                {
                    name: 'Zip',
                    checked: true,
                    property_name: 'zip',
                },
                {
                    name: 'Pipeline',
                    checked: true,
                    property_name: 'pipeline_value',
                },
                {
                    name: 'Company Type',
                    checked: true,
                    property_name: 'company_type',
                },
                {
                    name: 'Closing Ratio',
                    checked: true,
                    property_name: 'closing_ratio',
                },
                ...stateCustomFields,
            ];
            if (companyState) {
                // companyState = companyState.filter((state) => {
                //     return (state.property_name !== "age" && state.property_name !== "meeting_date")
                // })
                const stateHash = companyState.reduce(function (map, obj) {
                    map[obj.name] = obj;
                    return map;
                }, {});
                newState = Object.values(stateHash);
            }else{
                const baseStateHash = newState.reduce(function (map, obj) {
                    map[obj.name] = obj;
                    return map;
                }, {});
                newState = Object.values(baseStateHash);
            }
            return {
                companies: '',
                filter: '',
                sort :{
                    direction: 'asc',
                    colunm: 'name'
                },
                page: 1,
                pagination: {
                    data: [],
                    meta: {},
                    links: {},
                },
                data_loading: true,
                zero_search_results: false,
                companyTypes:[],
                advanced_search: false,
                advanced_form:{
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code:'',
                    phone: '',
                    fax:'',
                    company_type:null,
                    created_date:'',
                    last_update:'',
                },
                current_search_pattern: '',
                columns: newState,
                columnsToShow: this.sharedAvailableColumns,
                availableSortingColumns: this.availableSort,
                currentOrder: {
                    sortBy: 'name',
                    direction: 'asc'
                },
                companyViewName: '',
                companyViewNameError: '',
                companyViewList: [],
                companyViewId: '',
                companyViewRename: '',
                companyViewRenameError: '',
                drag: false,
            }
        },
        components:{CompanyExportIcon, Multiselect,Datepicker},
        created() {
            this.fetchData();
            this.getCompanyTypes();
            this.fetchCompaniesView();
        },
        methods: {

            goToPage(page) {
                this.page = page;
                this.advanced_search ? this.advancedSearch() : this.fetchData();
            },

            fetchData() {
                let params = {
                    filter: this.filter,
                    colunm:this.currentOrder.sortBy,
                    direction: this.currentOrder.direction,
                    page: this.page
                };

                this.data_loading = true;
                axios.get(route('api.shared-company.index'), {params}).then(({data}) => {
                    this.companies = data.data;
                    this.pagination = data;
                    this.data_loading = false;
                    this.zero_search_results = (this.filter && this.companies.length === 0);
                });
            },

            debounceFilter: _.debounce(function (e) {
                this.filter = e.target.value;
                this.advanced_search = false;
                this.goToPage(1)
            }, 700),

            showCompany(company) {
                window.location = route('company.show', {company:company.id});
            },

            addCompany() {
                window.location = route('company.create');
            },
            contractName(company){
                return `${company.contact.title ? company.contact.title : ''} ${company.contact.name ? company.contact.name : ''}`;
            },

            // sortBy(colunm){
            //     this.sort.direction = this.sort.colunm === colunm ? (this.sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';
            //     this.sort.colunm = colunm;
            //     this.goToPage(1);
            // },

            getCompanyTypes() {
                let self = this;
                axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                    self.companyTypes = data;
                    self.companyTypes.push({id:null,code:""})
                });
            },

            advancedSearch(hasFilter = false, filter = null){
                let params = {};
                if(hasFilter) {
                    params = filter;
                } else {
                    params = {
                        page:this.page,
                        colunm:this.sort.colunm,
                        direction: this.sort.direction,
                        advanced_filter: true,
                        ...this.advanced_form
                    };
                    params.company_type = params.company_type ? params.company_type.id : null;
                }
                this.data_loading = true;
                axios.get(route('api.company.index'), {params}).then(({data}) => {
                    this.companies = data.data;
                    this.pagination = data;
                }).finally(()=>{
                    this.data_loading = false;
                });
            },
            resetAdvancedForm(){
                this.advanced_form = {
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code:'',
                    phone: '',
                    fax:'',
                    company_type:null,
                    created_date:'',
                    last_update:'',
                };
            },
            updateColumnState(updatedStates) {
                this.columnsToExport = updatedStates.filter((updatedState) => {
                    if(updatedState.checked){
                        return updatedState
                    }
                })
            },
            sortByColumn(sortBy) {
                if (sortBy === this.currentOrder.sortBy) {
                    this.currentOrder.direction = (this.currentOrder.direction === 'asc') ? 'desc' : 'asc'
                }else {
                    this.currentOrder.sortBy = sortBy
                    this.currentOrder.direction = 'desc';
                }
                localStorage.setItem('companies.sortBy', this.currentOrder.sortBy);
                localStorage.setItem('companies.direction', this.currentOrder.direction);
                this.goToPage(1);
            },

            fetchCompaniesView() {
                axios.get(route('api.company.company-view-list'))
                    .then(({data}) => {
                        this.companyViewList = data.data
                        this.onUpdate();
                });
            },

            applyFilter(view) {
                this.advancedSearch(true, view.filter);
            },

            onUpdate() {
                let self = this;
                self.companyViewList.forEach((viewList, index) => {
                    viewList.load_order = index;
                });
                axios.put(route('api.company.view-list-order'), self.companyViewList);
            },

        }
    }
</script>

<style>
    .pagination > li > a {
        color: #4dc0b5;
    }

    .pagination > li > a:hover {
        background-color: #4dc0b5 !important;
        color: white;
    }

    .cursor-pointer {
        cursor:pointer;
    }

    li.page-item.active > a {
        background-color: #4dc0b5 !important;
        border-color: #4dc0b5 !important;
    }

    a.page-link:focus {
        box-shadow: none;
    }

    .company-listing-dropdown-button{
        border-color: #14b1af !important;
        color: #14b1af !important;
    }

    .overflowStyle{
        overflow: auto;
    }

    .custom-height-class {
        height: 150px;
    }

    .company-listing-dropdown-button:hover,
    .company-listing-dropdown-button:active,
    .company-listing-dropdown-button:focus,
    .company-listing-dropdown-button:visited,
    .company-listing-dropdown-button:focus-visible,
    .company-listing-dropdown-button:focus-within,
    .company-listing-dropdown-button:target,
    .company-listing-dropdown-button .show > .btn-outline-success.dropdown-toggle {
        border-color: #14b1af !important;
        color: #ffffff !important;
        background-color: #14b1af !important;
        box-shadow:none !important;
    }

    /* .add-view-button {
        font-size: 13px;
        color: #14b1af;
        margin: 8px;
        outline: unset;
    } */
</style>
